/* src/app/pages/data-compilation/dialog/dialog.component.scss */
/*# sourceMappingURL=dialog.component.css.map */
